import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetInterest } from "../queries/interests";
import { ENTITY } from "../constants";

export const InterestBreadcrumb = ({ match }) => {
    // Entity
    const { INTEREST } = ENTITY;

  const {
    data: interest,
    isLoading,
    isError,
    error,
  } = useGetInterest(match.params.interestId);

  if (isLoading) {
    //return <span>Loading...</span>;
    return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
  }

  if (isError && error instanceof NotFoundException) {
    return <span>Not found</span>;
  }

  if (interest) {
    return <span>{trimString(interest[INTEREST.nameField], 20)}</span>;
  }

  return null;
};
